export default {
    "sv-SE": {

    },
    "en-US": {
        poi_name: "POI name",
        latitude: "latitude",
        longitude: "longitude",
        poi_type: "POI type"
    }
};



// WEBPACK FOOTER //
// ./src/translations.ts